export default "/assets/images/performance-filter-img-01.88f3e177692d16b3.png";